import logo from "./logo.svg";
import "./App.css";
import { dataList, parseURLParams } from "./common/helper";
import { useEffect, useRef, useState } from "react";
import Popup from "./common/Popup";
import Loader from "./common/Loader";
import $ from "jquery";
import AlreadyJoined from "./AlreadyJoined";

function App() {
  // const [selectedState, setSelectedState] = useState("Bihar");
  // const [selectedState, setSelectedState] = useState("");
  // const [loksabhaval, setLoksabhaVal] = useState([]);
  // const [vidhansabha, setVidhansabhaVal] = useState("");
  // const [mandalval, setMandalval] = useState("");
  // const [boothval, setBoothval] = useState("");

  // const [selectedLoksabha, setSelectedLoksabha] = useState("");
  // const [selectedVidhan, setSelectedVidhan] = useState("");
  // const [selectedMandal, setSelectedMandal] = useState("");
  // const [selectedBooth, setselectedBooth] = useState("");
  const [Flag, setFlag] = useState("");
  const [userid, setUserid] = useState("");
  const [description, setDescription] = useState("");
  // const [sthaan, setSthaan] = useState("");
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [popup, setPopup] = useState(false);
  const [showDiv, setShowDiv] = useState(false);
  const [alreadyJoined, setAlreadyJoined] = useState(false);
  const [msg, setMsg] = useState("");

  const formRef = useRef(null);

  const handleFocus = (event) => {
    const { currentTarget } = event;
    // setShowDiv(true);
    // const { currentTarget } = event;
    // currentTarget.scrollIntoView({
    //   behavior: "smooth",
    //   block: "center",
    // });
    if (currentTarget.value.length > 1000) {
      alert("Message cannot exceed 1000 characters.");
    }
  };

  useEffect(() => {
    if (showDiv) {
      window.scrollTo(0, document.body.scrollHeight);
    }
  }, [showDiv]);
  useEffect(() => {
    const handleResize = () => {
      // Adjust form height or padding based on the window size
      const isKeyboardOpen = window.innerHeight < 1000; // Example condition
      if (formRef.current) {
        formRef.current.style.paddingBottom = isKeyboardOpen
          ? window.innerHeight / 2
          : "0";
      }
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    var urlParams = parseURLParams(window.location.href);
    let user_id = "";

    try {
      let href = window.location.href;
      href = href.split("?userid=")[1];
      user_id = href.split("&")[0];
    } catch (error) {}

    var userid =
      urlParams && urlParams["userid"]
        ? urlParams["userid"][0]
        : user_id
        ? user_id
        : "";

    if (userid) {
      setUserid(userid);
    }
  }, []);

  // useEffect(() => {
  //   getLoksabhaList();
  // }, []);

  // const getLoksabhaList = async () => {
  //   console.log("bye");
  //   const myHeaders = new Headers();
  //   myHeaders.append(
  //     "Cookie",
  //     "ak_bmsc=36C76E646A2BE1005579DA9640328B9F~000000000000000000000000000000~YAAQtCEPF3LC6IqOAQAAztUumBeGRdTCeSKeJMes5Gh8c+iySpbXAK8Qhu8ogJEAQm2MB7FbwQwq7vdGt82US/w8cdxRDYvXYuYdS9jHHa5tHHHbrndJx88Ai1z0i/qvB7XAS/I6Qa+46B4A87ThIS/CZgTcvlQtDVqrnGA5jfF6e4dx6cA1j7fJU4xc5gICxv8kzr23bs5tMWxAURZyG5Dn4xbfwkPQRsqOOhGOy46dGsvu2aLDSJw/d5COk2E/HlgRe2OqWTs8i/z3Tqs7hldoAQV2gUwP3U9DR6EDiOy4Os2nUlx/+yyjPxtoiWW0StGYy6OoCjKRYSiDuuSUIpV1BiCrq0HRUlqL1cgtBQliG6cM3s95XZnD1F7OXqUstfY=; bm_sv=9C4E72A00B05D85C6A8D438C88C2146F~YAAQziEPF1Zjg4WOAQAABgcxmBeTKATKxd/JW30d1A2CEVPVD0khlw3DmUEDXgywJmDLvJ//d7gB23pUQ45o5Q8wHl/70tlODbkqzQx9WbDCVmewlu7i6NQB9i2orGLhAt1YA0TYDZKFFT6dxXKvwPZbiiP5RGbTNkDlfFPwTML3RlnKoNC+ewiVvY+jFKW67laJ3jbPjRsT+oWM4NhrK1YslckbM7TwA1UczFSQa4+93RBWruNZI0OS5BPa0EX0Rhg1nGI=~1; ADRUM_BT=R%3A0%7Cg%3A1e8c9d7e-cee7-4ae0-ba00-76ced1bc44731068%7Cn%3Atmp_bjp_fb49d1de-d391-478a-ab5f-c84d7b25602e%7Ci%3A37735%7Cd%3A7%7Ce%3A58; NSC_10.10.24.75_443=ffffffff0902065045525d5f4f58455e445a4a423660"
  //   );
  //   const formdata = new FormData();
  //   formdata.append("action", "loksabha");
  //   formdata.append("userid", userid);
  //   formdata.append("state", "Delhi");

  //   const requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: formdata,
  //     redirect: "follow",
  //   };

  //   fetch("https://api.narendramodi.in/mlapiv1", requestOptions)
  //     .then((response) => response.json())
  //     .then((result) => setLoksabhaVal(result.data))
  //     .catch((error) => console.log("error", error));
  // };

  // const getVidhansabhaList = async (loksabha) => {
  //   setSelectedLoksabha(loksabha);
  //   const myHeaders = new Headers();
  //   myHeaders.append(
  //     "Cookie",
  //     "ak_bmsc=36C76E646A2BE1005579DA9640328B9F~000000000000000000000000000000~YAAQtCEPF3LC6IqOAQAAztUumBeGRdTCeSKeJMes5Gh8c+iySpbXAK8Qhu8ogJEAQm2MB7FbwQwq7vdGt82US/w8cdxRDYvXYuYdS9jHHa5tHHHbrndJx88Ai1z0i/qvB7XAS/I6Qa+46B4A87ThIS/CZgTcvlQtDVqrnGA5jfF6e4dx6cA1j7fJU4xc5gICxv8kzr23bs5tMWxAURZyG5Dn4xbfwkPQRsqOOhGOy46dGsvu2aLDSJw/d5COk2E/HlgRe2OqWTs8i/z3Tqs7hldoAQV2gUwP3U9DR6EDiOy4Os2nUlx/+yyjPxtoiWW0StGYy6OoCjKRYSiDuuSUIpV1BiCrq0HRUlqL1cgtBQliG6cM3s95XZnD1F7OXqUstfY=; bm_sv=9C4E72A00B05D85C6A8D438C88C2146F~YAAQziEPF1Zjg4WOAQAABgcxmBeTKATKxd/JW30d1A2CEVPVD0khlw3DmUEDXgywJmDLvJ//d7gB23pUQ45o5Q8wHl/70tlODbkqzQx9WbDCVmewlu7i6NQB9i2orGLhAt1YA0TYDZKFFT6dxXKvwPZbiiP5RGbTNkDlfFPwTML3RlnKoNC+ewiVvY+jFKW67laJ3jbPjRsT+oWM4NhrK1YslckbM7TwA1UczFSQa4+93RBWruNZI0OS5BPa0EX0Rhg1nGI=~1; ADRUM_BT=R%3A0%7Cg%3A1e8c9d7e-cee7-4ae0-ba00-76ced1bc44731068%7Cn%3Atmp_bjp_fb49d1de-d391-478a-ab5f-c84d7b25602e%7Ci%3A37735%7Cd%3A7%7Ce%3A58; NSC_10.10.24.75_443=ffffffff0902065045525d5f4f58455e445a4a423660"
  //   );
  //   const formdata = new FormData();
  //   formdata.append("action", "vidhansabha");
  //   formdata.append("userid", userid);
  //   formdata.append("loksabha", loksabha);

  //   const requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: formdata,
  //     redirect: "follow",
  //   };

  //   fetch("https://api.narendramodi.in/mlapiv1", requestOptions)
  //     .then((response) => response.json())
  //     .then((result) => setVidhansabhaVal(result.data))
  //     .catch((error) => console.log("error", error));
  // };

  // const getMandalList = async (vidhan) => {
  //   setSelectedVidhan(vidhan);
  //   const myHeaders = new Headers();
  //   myHeaders.append(
  //     "Cookie",
  //     "ak_bmsc=36C76E646A2BE1005579DA9640328B9F~000000000000000000000000000000~YAAQtCEPF3LC6IqOAQAAztUumBeGRdTCeSKeJMes5Gh8c+iySpbXAK8Qhu8ogJEAQm2MB7FbwQwq7vdGt82US/w8cdxRDYvXYuYdS9jHHa5tHHHbrndJx88Ai1z0i/qvB7XAS/I6Qa+46B4A87ThIS/CZgTcvlQtDVqrnGA5jfF6e4dx6cA1j7fJU4xc5gICxv8kzr23bs5tMWxAURZyG5Dn4xbfwkPQRsqOOhGOy46dGsvu2aLDSJw/d5COk2E/HlgRe2OqWTs8i/z3Tqs7hldoAQV2gUwP3U9DR6EDiOy4Os2nUlx/+yyjPxtoiWW0StGYy6OoCjKRYSiDuuSUIpV1BiCrq0HRUlqL1cgtBQliG6cM3s95XZnD1F7OXqUstfY=; bm_sv=9C4E72A00B05D85C6A8D438C88C2146F~YAAQziEPF1Zjg4WOAQAABgcxmBeTKATKxd/JW30d1A2CEVPVD0khlw3DmUEDXgywJmDLvJ//d7gB23pUQ45o5Q8wHl/70tlODbkqzQx9WbDCVmewlu7i6NQB9i2orGLhAt1YA0TYDZKFFT6dxXKvwPZbiiP5RGbTNkDlfFPwTML3RlnKoNC+ewiVvY+jFKW67laJ3jbPjRsT+oWM4NhrK1YslckbM7TwA1UczFSQa4+93RBWruNZI0OS5BPa0EX0Rhg1nGI=~1; ADRUM_BT=R%3A0%7Cg%3A1e8c9d7e-cee7-4ae0-ba00-76ced1bc44731068%7Cn%3Atmp_bjp_fb49d1de-d391-478a-ab5f-c84d7b25602e%7Ci%3A37735%7Cd%3A7%7Ce%3A58; NSC_10.10.24.75_443=ffffffff0902065045525d5f4f58455e445a4a423660"
  //   );
  //   const formdata = new FormData();
  //   formdata.append("action", "mandal");
  //   formdata.append("userid", userid);
  //   formdata.append("loksabha", selectedLoksabha);
  //   formdata.append("vidhansabha", vidhan);

  //   const requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: formdata,
  //     redirect: "follow",
  //   };

  //   fetch("https://api.narendramodi.in/mlapiv1", requestOptions)
  //     .then((response) => response.json())
  //     .then((result) => setMandalval(result.data))
  //     .catch((error) => console.log("error", error));
  // };

  // const getBoothList = async (mandal) => {
  //   setselectedBooth(mandal);
  //   const myHeaders = new Headers();
  //   myHeaders.append(
  //     "Cookie",
  //     "ak_bmsc=36C76E646A2BE1005579DA9640328B9F~000000000000000000000000000000~YAAQtCEPF3LC6IqOAQAAztUumBeGRdTCeSKeJMes5Gh8c+iySpbXAK8Qhu8ogJEAQm2MB7FbwQwq7vdGt82US/w8cdxRDYvXYuYdS9jHHa5tHHHbrndJx88Ai1z0i/qvB7XAS/I6Qa+46B4A87ThIS/CZgTcvlQtDVqrnGA5jfF6e4dx6cA1j7fJU4xc5gICxv8kzr23bs5tMWxAURZyG5Dn4xbfwkPQRsqOOhGOy46dGsvu2aLDSJw/d5COk2E/HlgRe2OqWTs8i/z3Tqs7hldoAQV2gUwP3U9DR6EDiOy4Os2nUlx/+yyjPxtoiWW0StGYy6OoCjKRYSiDuuSUIpV1BiCrq0HRUlqL1cgtBQliG6cM3s95XZnD1F7OXqUstfY=; bm_sv=9C4E72A00B05D85C6A8D438C88C2146F~YAAQziEPF1Zjg4WOAQAABgcxmBeTKATKxd/JW30d1A2CEVPVD0khlw3DmUEDXgywJmDLvJ//d7gB23pUQ45o5Q8wHl/70tlODbkqzQx9WbDCVmewlu7i6NQB9i2orGLhAt1YA0TYDZKFFT6dxXKvwPZbiiP5RGbTNkDlfFPwTML3RlnKoNC+ewiVvY+jFKW67laJ3jbPjRsT+oWM4NhrK1YslckbM7TwA1UczFSQa4+93RBWruNZI0OS5BPa0EX0Rhg1nGI=~1; ADRUM_BT=R%3A0%7Cg%3A1e8c9d7e-cee7-4ae0-ba00-76ced1bc44731068%7Cn%3Atmp_bjp_fb49d1de-d391-478a-ab5f-c84d7b25602e%7Ci%3A37735%7Cd%3A7%7Ce%3A58; NSC_10.10.24.75_443=ffffffff0902065045525d5f4f58455e445a4a423660"
  //   );
  //   const formdata = new FormData();
  //   formdata.append("action", "booth");
  //   formdata.append("userid", userid);
  //   formdata.append("loksabha", selectedLoksabha);
  //   formdata.append("vidhansabha", selectedVidhan);
  //   formdata.append("mandal", mandal);

  //   const requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: formdata,
  //     redirect: "follow",
  //   };

  //   fetch("https://api.narendramodi.in/mlapiv1", requestOptions)
  //     .then((response) => response.json())
  //     .then((result) => setBoothval(result.data))
  //     .catch((error) => console.log("error", error));
  // };

  const proceedHandler = async (e) => {
    setLoading(true);
    let numOfError = 0;

    if (numOfError >= 1) {
      setLoading(false);
      return false;
    }

    const myHeaders = new Headers();

    const formdata = new FormData();
    formdata.append("action", "joindiscussion");
    formdata.append("userid", userid);
    formdata.append("taskid", "6791c66b5e9b922d95078c4f"); //haryana state task id
    formdata.append("flag", "1");
    // formdata.append("loksabha", selectedLoksabha);
    // formdata.append("vidhansabha", selectedVidhan);
    // formdata.append("mandal", selectedMandal);
    // formdata.append("booth", selectedBooth);
    formdata.append("message", description);

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: formdata,
      redirect: "follow",
    };

    fetch("https://api.narendramodi.in/mlapiv1", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        if (result && result._resultflag == "1") {
          try {
            let obj = {};
            window.gtag("event", `Submitted`, obj);
          } catch (error) {}
          // setFlag(result._resultflag);
          setCount(result.total_participants);
          setAlreadyJoined(true);
        } else {
          // setFlag(result._resultflag);
          setPopup(true);
          setMsg(result?.message ? result?.message : "Something went wrong!");
        }
        setLoading(false);
      })
      .catch((error) => console.error(error));
  };

  const isAlreadyJoined = async (id) => {
    try {
      const myHeaders = new Headers();

      const formdata = new FormData();
      formdata.append("action", "joindiscussion");
      formdata.append("userid", id);
      formdata.append("taskid", "6791c66b5e9b922d95078c4f"); //haryana state task id
      formdata.append("flag", "1");
      formdata.append("checking", "1");
      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: formdata,
        redirect: "follow",
      };

      let response = await fetch(
        "https://api.narendramodi.in/mlapiv1",
        requestOptions
      );
      let result = await response.json();
      if (result?.message === "You have already Joined!") {
        setAlreadyJoined(true);
        setCount(result.total_participants);

        return true;
      } else {
        setAlreadyJoined(false);
        return false;
      }
      // if(result)
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    if (userid) {
      isAlreadyJoined(userid);
    }
  }, [userid]);

  if (alreadyJoined) {
    return <AlreadyJoined count={count} />;
  }

  return (
    <>
      {loading && <Loader />}
      <div className="tif_bg">
        <img
          // src="https://cdn.narendramodi.in/cmsuploads/0.67217400_1711961796_image-1.jpg"
          src="/assets/odisha_banner.jpeg"
          className="img_tif"
          alt=""
        />
        <div className="tif_pos">
          {/* <h3>"मेरा बूथ सबसे मजबूत" संवाद में आपका स्वागत है।</h3>
          <div className="sel_brd">
            <select
              id="state"
              value={selectedState}
              onChange={(e) => {
                setSelectedState(e.target.value);
                getLoksabhaList();
              }}
            >
              <option value="">राज्य (State)</option>
              <option value="Delhi">Delhi</option>
            </select>
            <img src="/assets/images/arrowdown.svg" alt="" />
          </div> */}
          {/* <div className="sel_brd">
            <select
              value={selectedLoksabha}
              onChange={(e) => {
                setSelectedLoksabha(e.target.value);
                getVidhansabhaList(e.target.value);
              }}
            >
              <option value="">लोकसभा (Lok Sabha)</option>
              {loksabhaval
                ? loksabhaval.map((element, index) => {
                    return (
                      <option key={index} value={element.loksabha}>
                        {element.loksabha}
                      </option>
                    );
                  })
                : ""}
            </select>
            <img src="/assets/images/arrowdown.svg" alt="" />
          </div> */}
          {/* <div className="sel_brd">
            <select
              value={selectedVidhan}
              onChange={(e) => {
                setSelectedVidhan(e.target.value);
                getMandalList(e.target.value);
              }}
            >
              <option value="">विधानसभा (Vidhansabha)</option>
              {vidhansabha
                ? vidhansabha.map((element, index) => {
                    return (
                      <option key={index} value={element.vidhansabha}>
                        {element.vidhansabha}
                      </option>
                    );
                  })
                : ""}
            </select>
            <img src="/assets/images/arrowdown.svg" alt="" />
          </div> */}
          {/* <div className="sel_brd">
            <select
              value={selectedMandal}
              onChange={(e) => {
                setSelectedMandal(e.target.value);
                // getBoothList(e.target.value);
              }}
            >
              <option value="">मंडल (Mandal)</option>
              {mandalval
                ? mandalval.map((element, index) => {
                    return (
                      <option key={index} value={element.mandal}>
                        {element.mandal}
                      </option>
                    );
                  })
                : ""}
            </select>
            <img src="/assets/images/arrowdown.svg" alt="" />
          </div> */}
          {/* <div className="sel_brd">
            <select
              value={selectedBooth}
              onChange={(e) => {
                setselectedBooth(e.target.value);
              }}
            >
              <option value="">Booth</option>
              {boothval
                ? boothval.map((element, index) => {
                    return (
                      <option key={index} value={element.booth}>
                        {element.booth}
                      </option>
                    );
                  })
                : ""}
            </select>
            <img src="/assets/images/arrowdown.svg" alt="" />
          </div> */}
          <div className="sel_brd sel_brd_flex">
            <textarea
              placeholder="Kindly share your suggestions here."
              value={description}
              rows={10}
              maxLength={1000}
              onChange={(e) => {
                setDescription(e.target.value);
              }}
              onFocus={handleFocus}
              onBlur={() => setShowDiv(false)}
            />
          </div>
          <button
            id="join_btn"
            className="join_btn"
            onClick={(e) => proceedHandler(e)}
          >
            Submit
          </button>
          {/* {showDiv && <div style={{ height: "400px" }}></div>} */}
        </div>
      </div>
      {popup && <Popup Flag={Flag} msg={msg} />}
    </>
  );
}

export default App;
